/** 流式调试：默认开启；关闭请 localStorage.setItem('zzlStreamDebug','0') 后刷新 */
export function isZzlStreamDebug() {
  try {
    if (typeof localStorage !== 'undefined') {
      const flag = localStorage.getItem('zzlStreamDebug');
      if (flag === '0') return false;
    }
  } catch (e) { /* ignore */ }
  return true;
}

export function zzlStreamLog(tag, data) {
  if (!isZzlStreamDebug()) return;
  if (data === undefined) {
    console.warn(`[zzl-stream] ${tag}`);
  } else {
    console.warn(`[zzl-stream] ${tag}`, data);
  }
}
